import * as yup from 'yup';

export const ConveyancingInquirySchema = yup.object().shape({
  propertyType: yup.string().required('Type is required'),
  propertyLocation: yup.string().required('Location is required'),
  timeline: yup.string().required('Timeline is required'),
  propertyAddress: yup.string().required('Address is required'),
});
